import VueCqrs from '@cqrs/vue-component-cqrs';
import * as c from '@Pages/Domain/commands-core';
import Component from 'vue-class-component';

@Component
export default class PagesCommands extends VueCqrs 
{
	invokeDeleteRequestPageCommandV1(workspaceId: number, projectId: number, pageId: number)
	{
		const cmd = new c.DeleteRequestPageCommandV1(workspaceId, projectId, pageId);
		this.$command(cmd, pageId.toString());
	}

	invokeCreateRequestPageCommandV1(workspaceId: number, projectId: number, pageId: number, name: string)
	{
		const cmd = new c.CreateRequestPageCommandV1(workspaceId, projectId, pageId, name);
		this.$command(cmd);
	}

	invokeCloneRequestPageCommandV1(workspaceId: number, projectId: number, pageId: number, cloneName: string)
	{
		const cmd = new c.CloneRequestPageCommandV1(workspaceId, projectId, pageId, cloneName);
		this.$command(cmd);
	}

	invokeUpdateRequestPageCommandV1(workspaceId: number, projectId: number, pageId: number, name: string, description: string, logoUrl: string, contentHtml: string, formId: number)
	{
		const cmd = new c.UpdateRequestPageCommandV1(workspaceId, projectId, pageId, name, description, logoUrl, contentHtml, formId);
		this.$command(cmd, pageId.toString());
	}
}